module.exports = __webpack_public_path__ + "static/img/3.bba29d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/detail/delivery/3.png
// module id = heiE
// module chunks = 1